import styled from 'styled-components';

export const Table = styled.table`
  font-size: ${({ theme }) => theme.V2.fonts.table.body}px;
  letter-spacing: ${({ theme }) => theme.V2.fonts.table.letterSpacing}px;
  border-spacing: ${({ theme }) => theme.V2.fonts.table.borderSpacing};
  table-layout: fixed;
`;

export const StyledRow = styled.tr`
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.V2.fonts.tableRowHover.backgroundColor};;
  }
`;

export const Th = styled.th`
  text-align: left;
  font-size: ${({ theme }) => theme.V2.fonts.tableHeader.size}px;
  font-weight: ${({ theme }) => theme.V2.fonts.tableHeader.weight};;
  color: ${({ theme }) => theme.V2.fonts.tableHeader.color};
  padding: ${({ theme }) => theme.V2.metrics.margin.small}px ${({ theme }) => theme.V2.metrics.margin.normal}px;
`;

export const ThRight = styled.th`
  text-align: right;
  padding:  ${({ theme }) => theme.V2.metrics.margin.small}px ${({ theme }) => theme.V2.metrics.margin.small}px;
`;

export const Td = styled.td`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: ${({ theme }) => theme.V2.metrics.margin.tiny}px ${({ theme }) => theme.V2.metrics.margin.normal}px;
`;

export const TdEmphasis = styled(Td)`
  color: ${({ theme }) => theme.V2.colors.warning};
  font-weight: bold;
`;




// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/components/CampaignDashboardTable.js